import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView, trackEngagement, trackConversion, trackEvent } from '../utils/analytics';

/**
 * Hook for automatic page view tracking and analytics utilities
 */
export const useAnalytics = () => {
  const location = useLocation();

  // Track page views automatically when location changes
  useEffect(() => {
    try {
      const pageTitle = document.title || 'Garage Sales';
      const pageLocation = window.location.href;
      
      trackPageView(pageTitle, pageLocation);
    } catch (error) {
      console.warn('Analytics page view tracking failed:', error);
    }
  }, [location]);

  return {
    trackEvent,
    trackEngagement,
    trackConversion,
  };
};

export default useAnalytics; 